var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "output",
    {
      staticClass: "composer-aviso ia-texto-corpo",
      class: _vm.classes,
      attrs: { "data-test": "composer-aviso" }
    },
    [
      _c("icon-svg", {
        staticClass: "composer-aviso__icone",
        attrs: {
          name: _vm.iconeEfetivo,
          size: _vm.tamanhoDoIcone,
          color: _vm.corDoIcone,
          "data-test": "composer-aviso-icone"
        }
      }),
      _c(
        "span",
        {
          staticClass: "composer-aviso__texto",
          attrs: { "data-test": "composer-aviso-texto" }
        },
        [_vm._v(_vm._s(_vm.texto))]
      ),
      _vm.temAcao
        ? _c(
            "button",
            {
              staticClass: "composer-aviso__acao",
              attrs: { type: "button", "data-test": "composer-aviso-acao" },
              on: { click: _vm.aoClicarAcao }
            },
            [_vm._v(" " + _vm._s(_vm.acao) + " ")]
          )
        : _vm._e(),
      _vm.fechavel
        ? _c(
            "button",
            {
              staticClass: "composer-aviso__fechar",
              attrs: {
                type: "button",
                "aria-label": _vm.rotuloDeFechar,
                title: _vm.rotuloDeFechar,
                "data-test": "composer-aviso-fechar"
              },
              on: { click: _vm.aoFechar }
            },
            [
              _c("icon-svg", {
                attrs: {
                  name: "close",
                  size: _vm.tamanhoDoIconeDeFechar,
                  color: "var(--neutral-600)"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }